import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ArchiveIcon = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("rect", {
    x: "3",
    y: "3",
    width: "18",
    height: "4",
    rx: "1"
  }), /*#__PURE__*/_jsx("path", {
    d: "M4,8H20a0,0,0,0,1,0,0V18.92A2.08,2.08,0,0,1,17.92,21H6.08A2.08,2.08,0,0,1,4,18.92V8A0,0,0,0,1,4,8Z"
  }), /*#__PURE__*/_jsx("rect", {
    x: "9",
    y: "11",
    width: "6",
    height: "2",
    rx: "0.43",
    fill: "#fff"
  }), /*#__PURE__*/_jsx("rect", {
    x: "8",
    y: "15",
    width: "8",
    height: "3",
    rx: "0.61",
    fill: "#fff"
  }), /*#__PURE__*/_jsx("rect", {
    x: "11",
    y: "16",
    width: "4",
    height: "1",
    rx: "0.5"
  }), /*#__PURE__*/_jsx("circle", {
    cx: "9.5",
    cy: "16.5",
    r: "0.5"
  })]
}), 'ArchiveIcon');